import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { FaMapMarkerAlt, FaBriefcase } from "react-icons/fa";

const OpenPositions = () => {
    const [jobs, setJobs] = useState([]);
    const [loading, setLoading] = useState(true);
    const [search, setSearch] = useState("");
    const [selectedLocation, setSelectedLocation] = useState("All");
    const [selectedType, setSelectedType] = useState("All");

    useEffect(() => {
        fetch(
            "https://appverselabs.codebuddys.in/wp-json/wp/v2/awsm_job_openings"
        )
            .then((res) => res.json())
            .then((data) => {
                setJobs(data);
                setLoading(false);
            })
            .catch((err) => {
                console.log(err);
                setLoading(false);
            });
    }, []);

    if (loading) {
        return (
            <section className="jobs-section">
                <h3 style={{ textAlign: "center" }}>
                    Loading Jobs...
                </h3>
            </section>
        );
    }

    const locations = [
        "All",
        ...new Set(
            jobs.map((job) => {
                const locationClass = job.class_list?.find((item) =>
                    item.startsWith("job-location-")
                );

                return locationClass
                    ? locationClass
                        .replace("job-location-", "")
                        .replace(/-/g, " ")
                    : "Remote";
            })
        ),
    ];

    const jobTypes = [
        "All",
        ...new Set(
            jobs.map((job) => {
                const typeClass = job.class_list?.find((item) =>
                    item.startsWith("job-type-")
                );

                return typeClass
                    ? typeClass
                        .replace("job-type-", "")
                        .replace(/-/g, " ")
                    : "Full Time";
            })
        ),
    ];

    const filteredJobs = jobs.filter((job) => {
        const locationClass = job.class_list?.find((item) =>
            item.startsWith("job-location-")
        );

        const typeClass = job.class_list?.find((item) =>
            item.startsWith("job-type-")
        );

        const location = locationClass
            ? locationClass
                .replace("job-location-", "")
                .replace(/-/g, " ")
            : "Remote";

        const jobType = typeClass
            ? typeClass
                .replace("job-type-", "")
                .replace(/-/g, " ")
            : "Full Time";

        const matchesSearch =
            job.title.rendered
                .toLowerCase()
                .includes(search.toLowerCase());

        const matchesLocation =
            selectedLocation === "All" ||
            location === selectedLocation;

        const matchesType =
            selectedType === "All" ||
            jobType === selectedType;

        return (
            matchesSearch &&
            matchesLocation &&
            matchesType
        );
    });

    return (
        <>
            <section className="jobs-section">

                <div className="jobs-glow glow-1"></div>
                <div className="jobs-glow glow-2"></div>

                <div className="jobs-container">

                    <div className="jobs-header">
                        <span>OPEN POSITIONS</span>

                        <h2>
                            Join Our
                            <br />
                            Growing Team
                        </h2>

                        <p>
                            Explore exciting opportunities and build
                            innovative products with a team that values
                            creativity, ownership and growth.
                        </p>
                    </div>

                    <div className="jobs-list">
                        <div className="job-filters">

                            <input
                                type="text"
                                placeholder="Search jobs..."
                                value={search}
                                onChange={(e) =>
                                    setSearch(e.target.value)
                                }
                            />

                            <select
                                value={selectedLocation}
                                onChange={(e) =>
                                    setSelectedLocation(e.target.value)
                                }
                            >
                                {locations.map((location) => (
                                    <option
                                        key={location}
                                        value={location}
                                    >
                                        {location}
                                    </option>
                                ))}
                            </select>

                            <select
                                value={selectedType}
                                onChange={(e) =>
                                    setSelectedType(e.target.value)
                                }
                            >
                                {jobTypes.map((type) => (
                                    <option
                                        key={type}
                                        value={type}
                                    >
                                        {type}
                                    </option>
                                ))}
                            </select>

                        </div>
                        {filteredJobs.map((job, index) => {

                            const locationClass =
                                job.class_list?.find((item) =>
                                    item.startsWith("job-location-")
                                );

                            const typeClass =
                                job.class_list?.find((item) =>
                                    item.startsWith("job-type-")
                                );

                            const location = locationClass
                                ? locationClass
                                    .replace("job-location-", "")
                                    .replace(/-/g, " ")
                                : "Remote";

                            const jobType = typeClass
                                ? typeClass
                                    .replace("job-type-", "")
                                    .replace(/-/g, " ")
                                : "Full Time";

                            return (
                                <div
                                    key={job.id}
                                    className="job-card"
                                >
                                    <div className="job-left">

                                        <div className="job-number">
                                            {String(index + 1).padStart(2, "0")}
                                        </div>

                                        <div>
                                            <h3>
                                                {job.title.rendered}
                                            </h3>

                                            <div className="job-meta">

                                                <span className="job-meta-item">
                                                    <FaMapMarkerAlt className="job-meta-icon" />
                                                    {location}
                                                </span>

                                                <span className="job-meta-item">
                                                    <FaBriefcase className="job-meta-icon" />
                                                    {jobType}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    <Link to={`/jobs/${job.slug}`}>
                                        <button>Apply Now →</button>
                                    </Link>
                                </div>
                            );
                        })}

                    </div>

                </div>
                <style>
                    {`.jobs-section {
    position: relative;
    padding: 150px 24px;
    background: #fff;
    overflow: hidden;
}
.job-meta-item{
    display:flex;
    align-items:center;
    gap:8px;

    font-size:14px;
    font-weight:500;
    color:#6b7280;
}

.job-meta-icon{
    color:#E8212A;
    font-size:14px;
}
.jobs-container {
    max-width: 1300px;
    margin: auto;
    position: relative;
    z-index: 2;
}

.jobs-header {
    text-align: center;
    margin-bottom: 70px;
}

.jobs-header span {
    display: inline-block;
    padding: 12px 22px;
    border-radius: 999px;
    background: rgba(232, 33, 42, .08);
    color: #E8212A;
    font-size: 13px;
    font-weight: 700;
    letter-spacing: 1px;
    margin-bottom: 24px;
}

.jobs-header h2 {
    font-size: clamp(35px, 7vw, 58px);
    line-height: .95;
    text-align: center;
    color: #111;
    margin-bottom: 20px;
    font-family: 'Syne', sans-serif;
}

.jobs-header p {
    max-width: 700px;
    margin: auto;
    color: #666;
    line-height: 1.9;
    text-align: center;
    font-size: 18px;
}

.jobs-list {
    display: flex;
    flex-direction: column;
    gap: 25px;
}

.job-card {
    background: #fff;
    border: 1px solid #eee;
    border-radius: 30px;
    padding: 35px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    transition: .4s ease;
    box-shadow:
        0 15px 40px rgba(0, 0, 0, .04);
}

.job-card:hover {
    transform: translateY(-8px);
    border-color: #E8212A;
    box-shadow:
        0 25px 80px rgba(232, 33, 42, .12);
}

.job-left {
    display: flex;
    align-items: center;
    gap: 30px;
}

.job-number {
    font-size: 60px;
    font-weight: 800;
    color: #E8212A;
    line-height: 1;
    font-family: 'Syne', sans-serif;
}

.job-card h3 {
    font-size: 34px;
    color: #111;
    margin-bottom: 15px;
    font-family: 'Syne', sans-serif;
}

.job-meta {
    display: flex;
    gap: 15px;
    flex-wrap: wrap;
}

.job-meta span {
    padding: 10px 18px;
    border-radius: 999px;
    background: #f8f8f8;
    color: #555;
    font-size: 14px;
}

.job-card button {
    border: none;
    cursor: pointer;
    padding: 16px 28px;
    border-radius: 16px;
    color: #fff;
    font-weight: 700;
    font-size: 15px;

    background:
        linear-gradient(135deg,
            #E8212A,
            #FF4D4D);

    box-shadow:
        0 20px 50px rgba(232, 33, 42, .22);

    transition: .3s;
}

.job-card button:hover {
    transform: translateY(-4px);
}

.jobs-glow {
    position: absolute;
    border-radius: 50%;
    filter: blur(120px);
    opacity: .12;
}

.glow-1 {
    width: 400px;
    height: 400px;
    background: #E8212A;
    top: -120px;
    left: -120px;
}

.glow-2 {
    width: 350px;
    height: 350px;
    background: #FF4D4D;
    right: -120px;
    bottom: -120px;
}

@media(max-width:991px) {

    .job-card {
        flex-direction: column;
        align-items: flex-start;
        gap: 25px;
    }

}
.job-filters{
    display:flex;
    gap:20px;
    margin-bottom:40px;
    flex-wrap:wrap;
    justify-content:center;
}

.job-filters input,
.job-filters select{
    padding:16px 20px;
    border:1px solid #eee;
    border-radius:14px;
    min-width:250px;
    font-size:15px;
    outline:none;
    background:#fff;
}

.job-filters input:focus,
.job-filters select:focus{
    border-color:#E8212A;
}
@media(max-width:768px) {

    .jobs-section {
        padding: 100px 18px;
    }

    .job-left {
        flex-direction: column;
        align-items: flex-start;
        gap: 15px;
    }

    .job-number {
        font-size: 42px;
    }

    .job-card h3 {
        font-size: 26px;
    }

    .jobs-header h2 {
        letter-spacing: -2px;
    }

}`}
                </style>
            </section>
        </>
    );
};

export default OpenPositions;